<template>
  <div class="">
    <img
      class="aspect-w-1 mx-auto object-center object-cover w-full hidden md:block md:h-screen"
      rel="preload"
      :src="desktopIllustration"
    />
    <img
      class="aspect-w-1 mx-auto object-center object-cover w-full block md:hidden"
      rel="preload"
      :src="mobileIllustration"
    />
  </div>
</template>

<script>
  export default {
    props: {
      /*
      illustration: {
        type: String,
        required: true,
      },
      */
      desktopIllustration: {
        type: String,
        required: true,
      },
      mobileIllustration: {
        type: String,
        required: true,
      },
      currentStep: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>
